import React from 'react'
import './Drinks.css'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import drinksImg from '../images/cold-drinks-res.jpg'
import { coffeeDecrease, coffeeIncrease, coldCoffeeDecrease, coldCoffeeIncrease, mangoDecrease, mangoIncrease, pepsiDecrease, pepsiIncrease } from '../redux/drinks/drinksActions'
import Order from './Order'


const Drinks = () => {
    const dispatch = useDispatch()
    const mango = useSelector(state => state.drinks.mango)
    const mangoPrice = useSelector(state => state.drinks.mangoPrice)
    const coldCoffee = useSelector(state => state.drinks.coldCoffee)
    const coldCoffeePrice = useSelector(state => state.drinks.coldCoffeePrice)
    const coffee = useSelector(state => state.drinks.coffee)
    const coffeePrice = useSelector(state => state.drinks.coffeePrice)
    const pepsi = useSelector(state => state.drinks.pepsi)
    const pepsiPrice = useSelector(state => state.drinks.pepsiPrice)
  return (
    <div className='drinks'>
        <ul className='drinksContainer'>
            <li className="drinkItem">
                <button onClick={() => dispatch(mangoIncrease())}>+</button>
                <p className='drnikItemP1'>Mango Juice - &#8377;50</p>
                <button onClick={() => {if(mango>0)dispatch(mangoDecrease())}}>-</button>
                <p className='drnikItemP2'>{mango} &#8377;{mangoPrice}</p>
            </li>
            <li className="drinkItem">
                <button onClick={() => dispatch(coldCoffeeIncrease())}>+</button>
                <p className='drnikItemP1'>Cold Coffee - &#8377;25</p>
                <button onClick={() => {if(coldCoffee>0)dispatch(coldCoffeeDecrease())}}>-</button>
                <p className='drnikItemP2'>{coldCoffee} &#8377;{coldCoffeePrice}</p>
            </li>
            <li className="drinkItem">
                <button onClick={() => dispatch(coffeeIncrease())}>+</button>
                <p className='drnikItemP1'>Cofee - &#8377;20</p>
                <button onClick={() => {if(coffee>0)dispatch(coffeeDecrease())}}>-</button>
                <p className='drnikItemP2'>{coffee} &#8377;{coffeePrice}</p>
            </li>
            <li className="drinkItem">
                <button onClick={() => dispatch(pepsiIncrease())}>+</button>
                <p className='drnikItemP1'>Pepsi - &#8377;60</p>
                <button onClick={() => {if(pepsi>0)dispatch(pepsiDecrease())}}>-</button>
                <p className='drnikItemP2'>{pepsi} &#8377;{pepsiPrice}</p>
            </li>
        </ul>
        <div className="foodButtons">
            <Link to='/food'><button  className='btn_text btn1'>Food</button></Link>
            <img src={drinksImg} alt="juice....." className='drinks__img'/>
            <Link to='/snacks'><button className='btn_text btn3'>Snacks</button></Link>
        </div>
        <Order />
    </div>
  )
}

export default Drinks